import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddNoteDialog from './addnotedialog';
import Note from '../domain/note';
import { saveNote as saveNoteLoc, editNote as editNoteLoc, removeNote as removeNoteLoc } from '../modules/locationdata';
import { saveNote as saveNoteCus, editNote as editNoteCus, removeNote as removeNoteCus } from '../modules/customerdata';
import ConfirmationDialog from '../common/confirmationdialog';
import { useTranslation } from 'react-i18next';
const _ = require('lodash');

export const TypeCustomer = 'customer';
export const TypeLocation = 'location';

export default function NotesView(props) {
    const dispatch = useDispatch();
    const locationsById = useSelector((state) => state.locationdata.locationsById);
    const customersById = useSelector((state) => state.customerdata.customersById);
    const userProfile = useSelector((state) => state.authentication.userProfile);
    const { t } = useTranslation();

    let notes = null;
    if (props.type === TypeLocation) {
        const locationFull = locationsById[props.id];
        notes = locationFull != null ? locationFull.notes : null;
    } else {
        const customerFull = customersById[props.id];
        notes = customerFull != null ? customerFull.notes : null;
    }

    const firstNote = (notes != null) & (notes.length > 0) ? notes[0] : null;
    const notesExcludingFirst = notes != null && notes.length > 1 ? _.slice(notes.slice(), 1) : [];

    const [noteDialogOpen, setNoteDialogOpen] = useState(false);
    const [viewExpanded, setViewExpanded] = useState(false);
    const [removeDialogOpen, setRemoveDialogOpen] = useState(false);
    const [noteEditMode, setNoteEditMode] = useState(false);
    const [noteToEdit, setNoteToEdit] = useState(null);
    const [noteToBeRemoved, setNoteToBeRemoved] = useState(null);

    const noteCount = notes != null ? notes.length : 0;

    const closeDialogRoutine = () => {
        setNoteDialogOpen(false);
        setRemoveDialogOpen(false);

        setNoteEditMode(false);
        setNoteToEdit(null);
        setNoteToBeRemoved(null);
    };

    const newNote = () => {
        setNoteDialogOpen(true);
    };

    const save = async (noteText, noteId) => {
        let note = new Note();
        note.storageId = noteId;
        note.text = noteText;
        note.userId = userProfile.id;
        if (props.type === TypeLocation) {
            note.locationId = props.id;
            if (noteId !== null) await editNoteLoc(note)(dispatch);
            else await saveNoteLoc(note)(dispatch);
        }
        if (props.type === TypeCustomer) {
            note.customerId = props.id;
            if (noteId !== null) await editNoteCus(note)(dispatch);
            else await saveNoteCus(note)(dispatch);
        }
        closeDialogRoutine();
    };

    const cancel = () => {
        closeDialogRoutine();
    };

    const accordionStateChange = (event, expanded) => {
        setViewExpanded(expanded);
    };

    const editNote = (event, note) => {
        event.stopPropagation();
        setNoteEditMode(true);
        setNoteToEdit(note);
        setNoteDialogOpen(true);
    };

    const removeNote = (event, note) => {
        event.stopPropagation();
        setNoteToBeRemoved(note);
        setRemoveDialogOpen(true);
    };

    const confirmRemove = async () => {
        if (props.type === TypeLocation) {
            await removeNoteLoc(noteToBeRemoved)(dispatch);
        }
        if (props.type === TypeCustomer) {
            await removeNoteCus(noteToBeRemoved)(dispatch);
        }
        closeDialogRoutine();
    };

    const cancelRemove = () => {
        closeDialogRoutine();
    };

    return (
        <Grid container>
            <Grid item xs={12}>
                <hr style={{ marginTop: '0' }} />
            </Grid>
            <Grid item xs={12}>
                <Grid container justifyContent={'space-between'}>
                    <Grid item>
                        <h5>
                            {t('general.notes')} ({noteCount} kpl)
                        </h5>
                    </Grid>
                    <Grid item>
                        <Button variant="contained" size="small" color="primary" name="btn-new-note" onClick={newNote}>
                            <AddIcon />
                        </Button>
                    </Grid>
                </Grid>
                {firstNote && (
                    <Accordion sx={{ marginTop: '10px' }} onChange={accordionStateChange}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} name="notes-panel">
                            <Grid container>
                                {firstNote.noteSaved.format('DD.MM.YYYY HH:mm')}: {firstNote.text} ..
                                {viewExpanded && (
                                    <Grid
                                        container
                                        alignItems={'flex-end'}
                                        alignContent={'flex-end'}
                                        justifyContent={'flex-end'}>
                                        <Grid item>
                                            <Button
                                                variant="contained"
                                                size="small"
                                                color="primary"
                                                name="btn-edit-note"
                                                onClick={(e) => editNote(e, firstNote)}
                                                startIcon={<EditIcon />}>
                                                {t('buttons.edit')}
                                            </Button>
                                            &nbsp;
                                            <Button
                                                variant="contained"
                                                size="small"
                                                color="secondary"
                                                name="btn-remove-note"
                                                onClick={(e) => removeNote(e, firstNote)}
                                                startIcon={<DeleteIcon />}>
                                                {t('buttons.remove')}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                        </AccordionSummary>
                        <AccordionDetails>
                            <List style={{ width: '100%' }}>
                                {notesExcludingFirst.map((item, ind) => (
                                    <ListItem sx={{ '&:hover': { cursor: 'pointer', backgroundColor: 'lightgray' } }} key={ind}>
                                        <Grid container>
                                            {item.noteSaved.format('DD.MM.YYYY HH:mm')}:{' '}
                                            <em style={{ whiteSpace: 'pre-line' }}>{item.text}</em>
                                            {viewExpanded && (
                                                <Grid
                                                    container
                                                    alignItems={'flex-end'}
                                                    alignContent={'flex-end'}
                                                    justifyContent={'flex-end'}>
                                                    <Grid item>
                                                        <Button
                                                            variant="contained"
                                                            size="small"
                                                            color="primary"
                                                            name="btn-edit-note"
                                                            onClick={(e) => editNote(e, item)}
                                                            startIcon={<EditIcon />}>
                                                            {t('buttons.edit')}
                                                        </Button>
                                                        &nbsp;
                                                        <Button
                                                            variant="contained"
                                                            size="small"
                                                            color="secondary"
                                                            name="btn-remove-note"
                                                            onClick={(e) => removeNote(e, item)}
                                                            startIcon={<DeleteIcon />}>
                                                            {t('buttons.remove')}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </ListItem>
                                ))}
                            </List>
                        </AccordionDetails>
                    </Accordion>
                )}
                {!firstNote && (
                    <Grid item>
                        <em>{t('general.noNotes')}</em>
                    </Grid>
                )}
                <AddNoteDialog
                    open={noteDialogOpen}
                    save={save}
                    cancel={cancel}
                    edit={noteEditMode}
                    note={noteToEdit}
                />
                <ConfirmationDialog
                    open={removeDialogOpen}
                    confirm={confirmRemove}
                    cancel={cancelRemove}
                    confirmText={'Poista'}>
                    <span>{t('general.confirmRemoveNote')}</span>
                </ConfirmationDialog>
            </Grid>
        </Grid>
    );
}
